import { Response } from "react-select-async-paginate";
import { getMachines } from "../../../api/machine";

import Machine from "../../../models/machine";
import AsyncPaginateBootstrap from "../../react-select-bootstrap/AsyncPaginateBootstrap";

const RECORS_PER_SEARCH = 5;

type GroupSetupMachineSelectProps = {
  value: Machine | null;
  disabled: boolean;
  onChange: (_: Machine | null) => void;
};

const GroupSetupMachineSelect: React.FC<GroupSetupMachineSelectProps> = ({
  value,
  disabled,
  onChange,
}) => {
  const loadMachineOptions = async (
    s: string,
    currentOpts: readonly (Machine | { options: Machine[]; label?: string })[]
  ): Promise<
    Response<Machine, { options: Machine[]; label?: string }, any>
  > => {
    let search: string | undefined = undefined;

    if (s !== "") {
      search = s;
    }

    const machinesPaginated = await getMachines(
      RECORS_PER_SEARCH,
      currentOpts.length,
      search
    );

    let newOpts: Machine[] = [];
    let count = 0;

    if (machinesPaginated.data !== undefined) {
      newOpts = machinesPaginated.data.items;
      count = machinesPaginated.data.count;
    }

    const hasMore = currentOpts.length + newOpts.length < count;

    return {
      options: newOpts,
      hasMore: hasMore,
    };
  };

  return (
    <AsyncPaginateBootstrap
      placeholder={"Seleccione una Máquina"}
      isDisabled={disabled}
      onChange={onChange}
      isMulti={false}
      debounceTimeout={300}
      loadOptions={loadMachineOptions}
      getOptionLabel={(option: Machine) => `${option.name}`}
      getOptionValue={(option: Machine) => `${option.id}`}
      value={value}
    />
  );
};

export default GroupSetupMachineSelect;
